// client/src/navigation/clearStaleSessionState.ts
//
// Side-effect-only module: on a fresh top-level navigation (not a reload, not
// an in-app back/forward — see freshNavigation.ts), drops every SESSION-tier
// storage key so a page landed on directly (e.g. retyping the app's URL after
// backing all the way out) doesn't resurrect a search/filter left over from
// before the tab's SPA history was abandoned. Import once, for its
// side effect, before the app's component tree mounts (index.tsx).
import { isFreshTopLevelNavigation } from './freshNavigation';
import { SESSION_STORAGE_KEYS } from '../utils/storageKeys';

if (isFreshTopLevelNavigation) {
  for (const key of SESSION_STORAGE_KEYS) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // sessionStorage unavailable — nothing to clear
    }
  }
}
